
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Asesores/[id]",
      function () {
        return require("private-next-pages/Asesores/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Asesores/[id]"])
      });
    }
  